webpackJsonp([2],{

/***/ 1974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1975);

__webpack_require__(426);

var _client = __webpack_require__(427);

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _client2.default)(window.__initialState);

/***/ }),

/***/ 1975:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1974]);


// WEBPACK FOOTER //
// list.1cb3d847c36652f91e5f.js